<ng-container *ngIf="(modals$ | async)?.length">
    <shared-modal-backdrop class="modals__backdrop" [isVisible]="(isClosingAllModals$ | async) === false"
        (onClick)="handleBackdropClick($event)">
    </shared-modal-backdrop>

    <ng-container *ngFor="let modal of (modals$ | async); trackBy: trackBy">
        <ng-container [ngSwitch]="modal.type">

            <shared-modal-for-active-order *ngSwitchCase="'active-order-prompt'" [modalData]="modal">
            </shared-modal-for-active-order>

            <shared-modal-for-alert *ngSwitchCase="'alert'" [modalData]="modal">
            </shared-modal-for-alert>

            <shared-modal-for-loading *ngSwitchCase="'loading'" [modalData]="modal">
            </shared-modal-for-loading>

            <shared-modal-for-location-open-hours *ngSwitchCase="'location-open-hours'" [modalData]="modal">
            </shared-modal-for-location-open-hours>

            <shared-modal-for-auth *ngSwitchCase="'auth'" [modalData]="modal">
            </shared-modal-for-auth>

            <shared-modal-for-single-product *ngSwitchCase="'product'" [modalData]="modal">
            </shared-modal-for-single-product>

            <shared-modal-for-menu-flow *ngSwitchCase="'standard-menu-flow'" [modalData]="modal">
            </shared-modal-for-menu-flow>

            <shared-modal-for-menu-flow *ngSwitchCase="'enhanced-menu-flow'" [modalData]="modal">
            </shared-modal-for-menu-flow>

            <shared-modal-for-menu-flow *ngSwitchCase="'combined-pages-menu-flow'" [modalData]="modal">
            </shared-modal-for-menu-flow>

            <shared-modal-for-menu-flow *ngSwitchCase="'step-through-menu-flow'" [modalData]="modal">
            </shared-modal-for-menu-flow>

            <shared-modal-for-menu-flow *ngSwitchCase="'upsell'" [modalData]="modal"></shared-modal-for-menu-flow>

            <shared-modal-for-history-order *ngSwitchCase="'history-order'" [modalData]="modal">
            </shared-modal-for-history-order>

            <shared-modal-for-transaction *ngSwitchCase="'transaction'" [modalData]="modal">
            </shared-modal-for-transaction>

            <shared-modal-for-reorder *ngSwitchCase="'reorder'" [modalData]="modal">
            </shared-modal-for-reorder>

            <shared-modal-for-reward *ngSwitchCase="'reward'" [modalData]="modal">
            </shared-modal-for-reward>

            <shared-modal-for-credit-card-add *ngSwitchCase="'credit-card-add'" [modalData]="modal">
            </shared-modal-for-credit-card-add>

            <shared-modal-for-member-card *ngSwitchCase="'member-card'" [modalData]="modal">
            </shared-modal-for-member-card>

            <shared-modal-for-order-types *ngSwitchCase="'order-types'" [modalData]="modal">
            </shared-modal-for-order-types>

            <shared-modal-for-schedule *ngSwitchCase="'schedule'" [modalData]="modal">
            </shared-modal-for-schedule>

            <shared-modal-for-delivery-address *ngSwitchCase="'delivery-address'" [modalData]="modal">
            </shared-modal-for-delivery-address>

            <shared-modal-for-delivery-not-available *ngSwitchCase="'delivery-not-available'" [modalData]="modal">
            </shared-modal-for-delivery-not-available>

            <shared-modal-for-dine-in *ngSwitchCase="'dine-in'" [modalData]="modal">
            </shared-modal-for-dine-in>

            <shared-modal-for-add-voucher *ngSwitchCase="'add-voucher'" [modalData]="modal">
            </shared-modal-for-add-voucher>

            <shared-modal-for-delete-profile *ngSwitchCase="'delete-profile'" [modalData]="modal">
            </shared-modal-for-delete-profile>

            <shared-modal-for-adyen-cvv *ngSwitchCase="'adyen-cvv'" [modalData]="modal">
            </shared-modal-for-adyen-cvv>

            <ng-container *ngSwitchDefault>
                <div class="modals__error">
                    <span class="modals__error-label">No modal defined for type: </span> <span
                        class="modals__error-value">{{modal.type}}</span>
                </div>
            </ng-container>

        </ng-container>
    </ng-container>

</ng-container>
